module.exports = __webpack_public_path__ + "img/R2S.8a01c240.png";